export default __webpack_public_path__ + "static/media/SWT0970.34I-27988_-16772_0.f28e8b62.jpg";